import { ReactElement } from 'react'
import { HexCodeDisplayer } from './HexCodeDisplayer'

const HEX_PATTERN = '#([a-fA-F0-9]{3}){1,2}\\b'

export const parseHexCodes = (text: string): (string | ReactElement)[] => {
  const regex = new RegExp(HEX_PATTERN, 'g')

  if (!regex.test(text)) return [text]

  regex.lastIndex = 0

  const parts: (string | ReactElement)[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index))
    }
    parts.push(<HexCodeDisplayer key={match.index} hex={match[0]} />)
    lastIndex = regex.lastIndex
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return parts
}
